import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "welcome-div" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center justify-center w-full h-full text-center px-4",
  style: {"font-size":"32px","padding-left":"40px","padding-right":"40px","font-weight":"bold","color":"white"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Establishing connection with server", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  id: "username",
  class: "row input-field"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "inputUsername" }, "Username:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = {
  id: "password",
  class: "row input-field"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "inputPassword" }, "Password:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "ROOM:", -1)
const _hoisted_12 = { class: "mb-5 mt-0" }
const _hoisted_13 = { class: "row input-field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "inputNickName" }, "Your name:", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "w-full btn-large waves-effect waves-dark cyan"
}, "Enter", -1)

import { useApi } from '@/composables/api';
import { useSession } from '@/composables/session';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const loading = ref(false)

const usernameRef = ref("");
const passwordRef = ref("");
const nicknameRef = ref("");
const route = useRoute();

const room = computed(() => route.query.room?.toString())


async function load() {
    loading.value = true
    try {
        await useSession().requestRTC();
    } catch (e) {
        alert(e)
    }
    loading.value = false;
}

async function onSubmit(e: Event) {
    e.preventDefault();

    if (!room.value) {
        var username = usernameRef.value;
        var password = passwordRef.value;
        if (!username || !password) {
            alert("You must to provide username and password to create a room.");
            return;
        }
        const resp = await useApi().usePost('/login', { username: username, password: password }, { headers: { "Content-Type": "application/json" } })
        if (resp.error && resp.message) {
            alert(resp.message);
            return;
        }
        if (resp.success) {
            await load()
            useSession().token.value = resp.token;
            //SÓ AQUI QUE ENTRA DE FATO NA SALA
            useSession().singin(username, nicknameRef.value, "224" + Date.now().toString().substring(5, 11), true)

            if (useSession().room && useSession().nickname) {

                // useSession().initServerChannelConnection("01");
            } else {
                alert("Nick name are required");
            }
        }
    } else {
        await load()
        useSession().singin(room.value, nicknameRef.value, "224" + Date.now().toString().substring(5, 11), false)

        if (useSession().room && useSession().nickname) {
            // useSession().initServerChannelConnection("01");
        } else {
            alert("Nick name are required");
        }
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          id: "roomForm",
          onSubmit: onSubmit
        }, [
          (!room.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    id: "inputUsername",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((usernameRef).value = $event)),
                    placeholder: "Insert your username",
                    type: "text"
                  }, null, 512), [
                    [_vModelText, usernameRef.value]
                  ]),
                  _hoisted_6
                ]),
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    id: "inputPassword",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordRef).value = $event)),
                    placeholder: "Insert your password",
                    type: "password"
                  }, null, 512), [
                    [_vModelText, passwordRef.value]
                  ]),
                  _hoisted_9
                ]),
                _hoisted_10
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_11,
                _createElementVNode("h2", _hoisted_12, _toDisplayString(room.value), 1)
              ], 64)),
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              id: "inputNickName",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((nicknameRef).value = $event)),
              placeholder: "Insert your name",
              type: "text",
              required: ""
            }, null, 512), [
              [_vModelText, nicknameRef.value]
            ]),
            _hoisted_14
          ]),
          _hoisted_15,
          _hoisted_16
        ], 32))
  ]))
}
}

})